module.exports = __webpack_public_path__ + "img/36_77.4c68a659.png";